//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const cdpStatsSlice = createSlice({
    name: 'cdpStatsSlc',
    initialState: {value: {
            marketGroupId: null, marketGroupName: null,
            releaseMarketId: null, releaseMarketName: null,
            seriesId: null, seasonId: null, productId: null,
            seriesTitle: null, seasonName: null, episodeName: null, photoStartDate: null,
            seasonNumber: null,
            gridDisplay: 'MarketGroupCdpStats',
            gridRefresh: null
        }},

    reducers:
    // {
    //     changeCdpStats: (state, action) => {
    //         state.value = action.payload;
    //     },
    // }
        {
            changeCdpStats: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeCdpStats } = cdpStatsSlice.actions;

export default  cdpStatsSlice.reducer ;
